import React from "react";
import {
  cancelButtonSVG,
  modalError,
  modalInfo,
} from "../../shared/images/icons";
import "./Modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { resetDATA, resetError, selectUser } from "../../actions/Actions";
import Button from "../../shared/Button/Button";
import { useHistory } from "react-router-dom";
import { UNKNOWN_USER } from "../constants/modal";

export const ModalView = ({
  redirect = false,
  onFail = false,
  closeModal,
  message = "",
  selectUsers = [],
  header = "",
  userSelectDialog = false,
  acceptButton = false,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const clientSource = useSelector((state) => state.mainState.redirect);

  const sendRoistatEvent = (userId) => {
    if (userId !== UNKNOWN_USER) {
      switch (clientSource) {
        case "sm":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_salom_docs_exist");
          break;
        case "auto":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_auto_docs_exist");
          break;
        case "visa":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_visa_docs_exist");
          break;
        case "alifshop":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_alifshop_docs_exist");
          break;
        case "default":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_docs_exist");
          break;
        default:
          break;
      }
    } else {
      switch (clientSource) {
        case "sm":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_salom_docs_not_found");
          break;
        case "auto":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_auto_docs_not_found");
          break;
        case "visa":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_visa_docs_not_found");
          break;
        case "alifshop":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_from_alifshop_docs_not_found");
          break;
        case "default":
          // eslint-disable-next-line no-undef
          roistat.event.send("doc_website_docs_not_found");
          break;
        default:
          break;
      }
    }
  };

  const handleSelectUser = (user) => {
    sendRoistatEvent(user.id);
    dispatch(selectUser(user));
    closeModal();
    history.push("/upload");
  };
  const handleClose = () => {
    if (redirect) {
      history.push("/");
      dispatch(resetDATA());
      dispatch(resetError());
      closeModal();
      return;
    }
    closeModal();
  };
  if (userSelectDialog) {
    return (
      <div
        className="modal-background"
        onClick={() => {
          handleClose();
        }}
      >
        <div className="modal-box">
          <div className="row">
            <div className="col-md-12">
              <div
                className="close-btn"
                onClick={() => {
                  handleClose();
                }}
              >
                {cancelButtonSVG}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="status-icon">
                <div>{onFail ? modalError : modalInfo}</div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="header-txt-modal">
                {selectUsers.length > 1 ? (
                  <>
                    Выберите вариант,
                    <br /> подходящий с вашим паспортом
                  </>
                ) : (
                  <>Это вы?</>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <ol className="user-list">
                {selectUsers.map((i) => (
                  <li className="user-name" onClick={() => handleSelectUser(i)}>
                    {i.id + 1}. {i.name}
                  </li>
                ))}
              </ol>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="dialog-actions">
                {selectUsers.length > 1 ? (
                  <div className="action-buttons">
                    <Button
                      label="Отмена"
                      size="small"
                      type="error outlined"
                      onClick={() => handleSelectUser({ id: -1 })}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="dialog-actions">
                {selectUsers.length > 1 ? null : (
                  <div className="action-buttons">
                    <Button
                      label="Да"
                      size="small"
                      type="outlined"
                      submitPermission={true}
                      onClick={() => {
                        handleSelectUser(selectUsers[0]);
                      }}
                    />
                    <Button
                      label="Нет"
                      size="small"
                      type="error outlined"
                      onClick={() => handleSelectUser({ id: -1 })}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="modal-background"
      onClick={() => {
        handleClose();
      }}
    >
      <div className="modal-box">
        <div className="row">
          <div className="col-md-12">
            <div
              className="close-btn"
              onClick={() => {
                handleClose();
              }}
            >
              {cancelButtonSVG}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="status-icon">{onFail ? modalError : modalInfo}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="header-txt-modal">{header}</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="message-txt-modal">{message}</div>
          </div>
        </div>
        {acceptButton && (
          <div className="row">
            <div className="col-md-12">
              <div className="dialog-actions">
                <Button
                  label="Понятно"
                  type="outlined"
                  size="small"
                  submitPermission={true}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
